import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PlanoAlimentar } from '../../models/PlanoAlimentar';
import axiosClient from '../../../shared/axios/axios-client';
import { SnackbarService } from '../snackbar/snackbar.service';
import { TacoAlimento } from '../../models/TacoAlimento';
import { PlanoStatus } from '../../models/PlanoStatus';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PlanoAlimentarService {
  private apiUrl = environment.apiUrl;
  planoStatusInativo = PlanoStatus.INATIVO;
  planoStatusAtivo = PlanoStatus.ATIVO;

  constructor(private snackbarService: SnackbarService) {}

  async listarPlanosAlimentares(idPessoa: number): Promise<PlanoAlimentar[]> {
    return await axiosClient
      .get(`${this.apiUrl}/pessoa/${idPessoa}/plano-alimentar`)
      .then((res) => (Array.isArray(res.data.data) ? res.data.data : []))
      .catch((err) => {
        this.snackbarService.error(err.response?.data?.error || err.message);
        throw err;
      });
  }

  async salvarPlanoAlimentar(
    idPessoa: number,
    plano: PlanoAlimentar
  ): Promise<PlanoAlimentar> {
    return await axiosClient
      .post(`${this.apiUrl}/pessoa/${idPessoa}/plano-alimentar`, plano)
      .then((res) => res.data)
      .catch((err) => {
        this.snackbarService.error(err.response?.data?.message || err.message);
        throw err;
      });
  }

  async editarPlanoAlimentar(
    idPessoa: number,
    plano: PlanoAlimentar
  ): Promise<PlanoAlimentar> {
    if (plano.status == this.planoStatusAtivo) {
      await this.inativarPlanoAlimentar(idPessoa, plano);
      return await axiosClient
        .post(`${this.apiUrl}/pessoa/${idPessoa}/plano-alimentar`, plano)
        .then((res) => res.data)
        .catch((err) => {
          this.snackbarService.error(err.response?.data?.message || err.message);
          throw err;
        });
    } else {
      return await axiosClient
        .put(`${this.apiUrl}/pessoa/${idPessoa}/plano-alimentar`, plano)
        .then((res) => res.data)
        .catch((err) => {
          this.snackbarService.error(err.response?.data?.message || err.message);
          throw err;
        });
    }
  }

  async inativarPlanoAlimentar(
    idPessoa: number,
    plano: PlanoAlimentar
  ): Promise<PlanoAlimentar> {
    const planoDto = {
      idPessoa: idPessoa,
      idPlano: plano.idPlanoAlimentar,
      status: this.planoStatusInativo
    }
    return await axiosClient
      .put(`${this.apiUrl}/pessoa/plano-alimentar/status`, planoDto)
      .then((res) => res.data)
      .catch((err) => {
        this.snackbarService.error(err.response?.data?.message || err.message);
        throw err;
      });
  }

  async buscarAlimentosTaco(descricao?: string): Promise<TacoAlimento[]> {
    return await axiosClient
      .get(`${this.apiUrl}/equilibria/alimentos-taco/listar`, {
        params: descricao ? { descricaoAlimento: descricao } : {},
      })
      .then((res) => (Array.isArray(res.data.data) ? res.data.data : []))
      .catch((err) => {
        this.snackbarService.error(err.response?.data?.error || err.message);
        throw err;
      });
  }

  async detalharAlimentoTaco(id: number): Promise<TacoAlimento> {
    return await axiosClient
      .get(`${this.apiUrl}/equilibria/alimentos-taco/buscar/${id}`)
      // .then(res => Array.isArray(res.data.data) ? res.data.data : [])
      .then((res) => {
        return res.data.data || [];
      })
      .catch((err) => {
        this.snackbarService.error(err.response?.data?.error || err.message);
        throw err;
      });
  }
}
